/**
 * AI GENERATED badge — freddy.com (Shopify, tema Symmetry)
 *
 * Applica il badge "AI GENERATED" a tutte le <img> la cui URL contiene "_ai_".
 * Funziona su: griglie collezione, hero/slideshow, gallery prodotto (slider mobile,
 * collage desktop) e gallery-viewer a tutto schermo. Gestisce lazy-load,
 * cambio variante e contenuti iniettati dinamicamente (MutationObserver).
 */
(function () {
  'use strict';

  var CFG = {
    // SVG del badge
    //badgeUrl: 'https://cdn.shopify.com/s/files/1/0655/2217/2092/files/LABEL_AI_GENERATED_black.svg?v=1787750217',
    //badgeUrl: 'https://cdn.shopify.com/s/files/1/0655/2217/2092/files/LABEL_AI_GENERATED_white_transparent.svg?v=1787816445',
    //badgeUrl: 'https://cdn.shopify.com/s/files/1/0655/2217/2092/files/LABEL_AI_GENERATED_white.svg?v=1787818184',
    //badgeUrl: 'https://cdn.shopify.com/s/files/1/0655/2217/2092/files/LABEL_AI_white_transparent.svg?v=1789483680',
    badgeUrl: 'https://cdn.shopify.com/s/files/1/0655/2217/2092/files/LABEL_AI_singola.svg?v=1789486657',
    // Come riconoscere un'immagine AI (testato sul solo path, senza querystring)
    pattern: /_ai_/i,
    // Posizione: 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'
    position: 'bottom-right',
    // Larghezza del badge (clamp per essere leggibile su mobile e desktop)
    width: 'clamp(20px, 6%, 32px)',   // era clamp(72px, 22%, 120px)
    // Distanza dai bordi dell'immagine
    offset: '8px',
    // Pastiglia bianca dietro il badge. Disattivata: l'SVG è nero, quindi su foto
    // molto scure il badge risulta poco leggibile. Rimettere a true se serve.
    pill: false,
    // Proporzioni di fallback del badge, sovrascritte a runtime leggendo l'SVG
    fallbackRatio: '300/95',
    // Non applicare a immagini piu' piccole di così (px) -> esclude micro-thumb
    minWidth: 120,
    // Contenitori/immagini da escludere sempre
    exclude: [
      '.thumbnail',
      '.thumbnails',
      '.gallery-viewer__thumb',
      '.sticky-atc',
      '.quick-add',
      '[data-no-ai-badge]'
    ].join(','),
    // Casi in cui il badge non va nel contenitore diretto dell'immagine.
    // mode 'overlay': badge in position:fixed, agganciato al box visivo
    // dell'immagine (transform incluse) e clampato all'area visibile di 'anchor'.
    // 'position' sovrascrive CFG.position solo per quell'ancora: nel viewer
    // full-screen il badge va in alto, perche' in basso finirebbe sulle miniature.
    anchors: [
      {
        img: '.gallery-viewer__zoom-image',
        anchor: 'gallery-viewer',
        mode: 'overlay',
        position: 'top-left'
      }
    ],
    // Overlay: larghezza = 22% del lato visibile dell'immagine, entro questi limiti
    overlayWidth: [22, 34],   // era [72, 120]
    overlayRatio: 0.06,       // era 0.22
    alt: 'Immagine generata con intelligenza artificiale'
  };

  var CLS = 'ai-gen-badge';
  var HOST_CLS = 'ai-gen-badge-host';

  /* ---------- CSS ---------- */

  function injectCss() {
    if (document.getElementById('ai-gen-badge-css')) return;
    var pos = {
      'bottom-left': 'bottom:' + CFG.offset + ';left:' + CFG.offset + ';',
      'bottom-right': 'bottom:' + CFG.offset + ';right:' + CFG.offset + ';',
      'top-left': 'top:' + CFG.offset + ';left:' + CFG.offset + ';',
      'top-right': 'top:' + CFG.offset + ';right:' + CFG.offset + ';'
    }[CFG.position] || 'bottom:' + CFG.offset + ';left:' + CFG.offset + ';';

    // "all:unset" azzera le regole del tema (es. .img-ar img{aspect-ratio;object-fit}
    // che deformavano il badge). Le custom property non vengono toccate da "all".
    var css =
      ':root{--ai-badge-url:url("' + CFG.badgeUrl + '");--ai-badge-ratio:' + CFG.fallbackRatio + ';}' +
      '.' + HOST_CLS + '{position:relative;}' +
      '.' + CLS + '{all:unset;display:block;position:absolute;' + pos +
        'z-index:3;box-sizing:border-box;width:' + CFG.width + ';max-width:60%;' +
        'pointer-events:none;' +
        (CFG.pill ? 'padding:4px 6px;background:rgba(255,255,255,.9);border-radius:4px;' : '') +
      '}' +
      '.' + CLS + '--overlay{position:fixed;bottom:auto;right:auto;left:0;top:0;width:auto;max-width:none;transform:none;}' +
      '.' + CLS + '>i{all:unset;display:block;width:100%;' +
        'aspect-ratio:var(--ai-badge-ratio);' +
        'background-image:var(--ai-badge-url);background-size:contain;' +
        'background-repeat:no-repeat;background-position:center;' +
      '}';

    var s = document.createElement('style');
    s.id = 'ai-gen-badge-css';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  // Legge le proporzioni reali dell'SVG una volta sola, per evitare deformazioni
  // e layout shift se il file del badge viene sostituito.
  function measureBadge() {
    var probe = new Image();
    probe.onload = function () {
      if (probe.naturalWidth && probe.naturalHeight) {
        document.documentElement.style.setProperty(
          '--ai-badge-ratio', probe.naturalWidth + '/' + probe.naturalHeight
        );
      }
    };
    probe.src = CFG.badgeUrl;
  }

  /* ---------- rilevamento ---------- */

  function isAiUrl(url) {
    if (!url) return false;
    return CFG.pattern.test(String(url).split('?')[0]);
  }

  // Le sorgenti dichiarate hanno la precedenza su currentSrc, che si aggiorna
  // in ritardo: al cambio variante un badge sarebbe rimasto su un'immagine non AI.
  function sourcesOf(img) {
    var out = [];
    var attrs = ['src', 'srcset', 'data-src', 'data-srcset', 'data-original', 'data-bgset'];
    for (var i = 0; i < attrs.length; i++) {
      var v = img.getAttribute(attrs[i]);
      if (v) out.push(v);
    }
    var pic = img.parentElement;
    if (pic && pic.tagName === 'PICTURE') {
      var sources = pic.querySelectorAll('source');
      for (var j = 0; j < sources.length; j++) {
        var sv = sources[j].getAttribute('srcset') || sources[j].getAttribute('data-srcset');
        if (sv) out.push(sv);
      }
    }
    if (!out.length && img.currentSrc) out.push(img.currentSrc);
    return out;
  }

  function isAiImage(img) {
    var src = sourcesOf(img);
    for (var i = 0; i < src.length; i++) {
      if (isAiUrl(src[i])) return true;
    }
    return false;
  }

  function isExcluded(img) {
    return CFG.exclude && img.closest(CFG.exclude) !== null;
  }

  function tooSmall(img) {
    var w = img.getBoundingClientRect().width;
    // width 0 = immagine nascosta (slide non attiva, breakpoint opposto): non escludere
    return w > 0 && w < CFG.minWidth;
  }

  function shouldBadge(img) {
    return isAiImage(img) && !isExcluded(img) && !tooSmall(img);
  }

  /* ---------- host del badge ---------- */

  function hostFor(img) {
    for (var i = 0; i < CFG.anchors.length; i++) {
      var a = CFG.anchors[i];
      if (img.matches(a.img)) {
        var anc = img.closest(a.anchor);
        if (anc) return { host: anc, mode: a.mode || 'corner', position: a.position };
      }
    }
    // wrapper aspect-ratio del tema: è il contenitore che coincide con l'immagine
    var candidate = img.closest('.img-ar');
    if (!candidate) {
      candidate = img.parentElement;
      // <picture> non può contenere altri figli: si sale di un livello
      if (candidate && candidate.tagName === 'PICTURE') candidate = candidate.parentElement;
    }
    if (!candidate) return null;

    var safe = safeHost(candidate, img);
    return { host: safe.host, mode: 'corner', relative: safe.relative };
  }

  // Rendere posizionato un contenitore static NON e' innocuo: cambia il
  // containing block dei suoi discendenti absolute. Nel listing i layer hover
  // hanno l'immagine in position:absolute dentro un .img-ar alto 0, quindi
  // aggiungere position:relative al .img-ar collassava l'immagine a altezza 0
  // e in hover non si vedeva piu' nulla.
  function hasPositionedDescendant(el) {
    var nodes = el.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.classList.contains(CLS) || n.closest('.' + CLS)) continue; // il nostro badge
      var pos = getComputedStyle(n).position;
      if (pos === 'absolute' || pos === 'fixed') return true;
    }
    return false;
  }

  function boxContains(outer, inner) {
    var o = outer.getBoundingClientRect(), i = inner.getBoundingClientRect();
    if (!o.width || !o.height) return false;
    return i.left >= o.left - 2 && i.right <= o.right + 2 &&
           i.top >= o.top - 2 && i.bottom <= o.bottom + 2;
  }

  // Restituisce il contenitore su cui ancorare il badge senza toccare il layout
  // del tema. 'relative' dice se andra' reso posizionato da noi.
  function safeHost(candidate, img) {
    if (getComputedStyle(candidate).position !== 'static') {
      return { host: candidate, relative: false };
    }
    if (!hasPositionedDescendant(candidate)) {
      return { host: candidate, relative: true };
    }
    // Si sale al primo antenato gia' posizionato: nel listing e' il layer stesso
    // (.product-block__image--secondary), che coincide col box dell'immagine e
    // ne condivide l'opacita', quindi il badge segue lo scambio in hover.
    var a = candidate.parentElement, best = null;
    for (var lvl = 0; a && a !== document.body && lvl < 4; lvl++, a = a.parentElement) {
      if (getComputedStyle(a).position === 'static') continue;
      if (!best) best = a;
      if (boxContains(a, img)) return { host: a, relative: false };
    }
    if (best) return { host: best, relative: false };
    return { host: candidate, relative: true };
  }

  function isOurNode(n) {
    return n && n.nodeType === 1 && (n.classList.contains(CLS) || n.id === 'ai-gen-badge-css');
  }

  /* ---------- riconciliazione ---------- */

  // Stateless per scelta: a ogni passata si ricalcola quali contenitori DEVONO
  // avere il badge e si allinea il DOM. Tenere lo stato per singola <img> non
  // funziona, perche' il gallery-viewer full-screen sostituisce l'elemento <img>
  // invece di aggiornarne il src: il badge del vecchio elemento restava orfano
  // e continuava a comparire anche sulle immagini non AI.
  function mount(host, needsRelative) {
    if (needsRelative) host.classList.add(HOST_CLS);
    var span = document.createElement('span');
    span.className = CLS;
    span.setAttribute('role', 'img');
    span.setAttribute('aria-label', CFG.alt);
    span.setAttribute('title', CFG.alt);
    span.appendChild(document.createElement('i')); // porta lo sfondo con l'SVG
    host.appendChild(span);
    return span;
  }

  function unmount(badge) {
    var host = badge.parentElement;
    badge.remove();
    if (host) host.classList.remove(HOST_CLS);
  }

  // Overlay: il badge segue il box VISIVO dell'immagine (la transform di zoom
  // inclusa), ma clampato all'area visibile del viewer. A zoom pieno l'immagine
  // e' piu' grande dello schermo e il suo angolo reale sarebbe fuori vista:
  // senza clamp il badge spartirebbe.
  function layoutOverlay(badge, img, area, position) {
    var ir = img.getBoundingClientRect();
    var ar = area.getBoundingClientRect();
    var x1 = Math.max(ir.left, ar.left), x2 = Math.min(ir.right, ar.right);
    var y1 = Math.max(ir.top, ar.top), y2 = Math.min(ir.bottom, ar.bottom);
    var vw = x2 - x1, vh = y2 - y1;
    if (vw < 48 || vh < 32) { badge.style.display = 'none'; return; }

    var off = parseFloat(CFG.offset) || 0;
    var w = Math.max(CFG.overlayWidth[0], Math.min(CFG.overlayWidth[1], vw * CFG.overlayRatio));
    badge.style.display = 'block';
    badge.style.width = Math.round(w) + 'px';

    // Coordinate volute, in px di viewport
    var br = badge.getBoundingClientRect();
    var place = position || CFG.position;
    var atRight = place.indexOf('right') !== -1;
    var atTop = place.indexOf('top') !== -1;
    var wantLeft = atRight ? x2 - off - br.width : x1 + off;
    var wantTop = atTop ? y1 + off : y2 - off - br.height;

    // Misura e corregge invece di calcolare l'offset dall'antenato: un antenato
    // con transform (qui .modal__window) cambia il containing block di un elemento
    // fixed, e qualunque calcolo basato sul viewport sarebbe sbagliato. Cosi'
    // funziona con qualsiasi containing block, anche scalato o animato.
    var scale = (br.width && badge.offsetWidth) ? br.width / badge.offsetWidth : 1;
    if (!scale) scale = 1;
    var curLeft = parseFloat(badge.style.left) || 0;
    var curTop = parseFloat(badge.style.top) || 0;
    badge.style.left = (curLeft + (wantLeft - br.left) / scale) + 'px';
    badge.style.top = (curTop + (wantTop - br.top) / scale) + 'px';
  }

  var overlays = []; // [{badge, img, area}] sincronizzati a ogni frame
  var syncing = false;

  function syncOverlays() {
    for (var i = 0; i < overlays.length; i++) {
      var o = overlays[i];
      if (!o.badge.isConnected || !o.img.isConnected) { overlays.splice(i--, 1); continue; }
      layoutOverlay(o.badge, o.img, o.area, o.position);
    }
    if (!overlays.length) { syncing = false; return; }
    requestAnimationFrame(syncOverlays);
  }

  // Lo zoom e' una transform inline animata e il pan muove l'immagine senza
  // eventi utili: un loop leggero, attivo solo mentre un badge overlay esiste,
  // e' il modo piu' semplice per restare agganciati.
  function startSync() {
    if (syncing || !overlays.length || document.hidden) return;
    syncing = true;
    requestAnimationFrame(syncOverlays);
  }

  function reconcile() {
    var hosts = [], claims = [];
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!shouldBadge(imgs[i])) continue;
      var res = hostFor(imgs[i]);
      if (!res || hosts.indexOf(res.host) !== -1) continue;
      hosts.push(res.host);
      claims.push({
        host: res.host, img: imgs[i], mode: res.mode,
        position: res.position, relative: res.relative
      });
    }

    // via i badge non piu' pertinenti (slide cambiata, variante cambiata, host orfano)
    var existing = document.querySelectorAll('.' + CLS);
    for (var j = 0; j < existing.length; j++) {
      if (hosts.indexOf(existing[j].parentElement) === -1) unmount(existing[j]);
    }

    overlays.length = 0;
    for (var k = 0; k < claims.length; k++) {
      var c = claims[k];
      var isOverlay = c.mode === 'overlay';
      // in overlay il badge e' position:fixed: l'host non va reso posizionato
      var badge = c.host.querySelector(':scope > .' + CLS) ||
        mount(c.host, !isOverlay && c.relative);
      badge.classList.toggle(CLS + '--overlay', isOverlay);
      if (isOverlay) {
        overlays.push({ badge: badge, img: c.img, area: c.host, position: c.position });
        layoutOverlay(badge, c.img, c.host, c.position);
      } else {
        badge.removeAttribute('style');
      }
    }
    startSync();
  }

  var scheduled = false;

  // requestAnimationFrame e' congelato nelle tab in background: se la pagina viene
  // aperta in una tab non attiva le callback non partono e gli aggiornamenti
  // resterebbero in sospeso. In quel caso si usa setTimeout.
  function defer(cb) {
    if (document.hidden) setTimeout(cb, 100);
    else requestAnimationFrame(cb);
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    defer(function () {
      scheduled = false;
      injectCss();
      reconcile();
    });
  }

  /* ---------- osservazione DOM ---------- */

  function observe() {
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'childList') {
          var relevant = false;
          for (var j = 0; j < r.addedNodes.length; j++) {
            if (!isOurNode(r.addedNodes[j])) { relevant = true; break; }
          }
          if (relevant) { scheduleScan(); return; }
        } else if (r.type === 'attributes') {
          if (isOurNode(r.target)) continue;
          scheduleScan();
          return;
        }
      }
    });
    mo.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset', 'class']
    });
  }

  function init() {
    injectCss();
    measureBadge();
    reconcile();
    observe();
    // lazy-load / decode tardivo / slider che ricalcolano il layout
    window.addEventListener('load', scheduleScan);
    window.addEventListener('resize', scheduleScan);
    document.addEventListener('visibilitychange', scheduleScan);
    ['variant:change', 'shopify:section:load', 'shopify:section:reorder', 'on:variant:change']
      .forEach(function (ev) { document.addEventListener(ev, scheduleScan); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();